import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * プロダクトスコープ棚卸しインスタンス詳細のインデックス。
 *
 * 本文は `_layout/detail` / `_layout/data` にあるため、タブ無しアクセスを
 * 「詳細」タブへリダイレクトする（PN「リリースプラン作成」/ QA と同パターン）。
 */
export const Route = createFileRoute('/_stacktrace/product-planning-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/')({
  beforeLoad: ({
    params
  }) => {
    throw redirect({
      to: '/product-planning-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/detail',
      params
    });
  }
});